import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import termsData from '@/features/support/notice/components/yuseoung-gu/TermsData'
import { COLOR } from '@/shared/constant/color'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { CustomBtn } from '@/styles/common/CommonForm/buttonform'
import {
  LayoutSubPage,
  LayoutWrap,
  NotFoundPageInner,
  NotFoundPageWrap,
  SubScriptDesc,
  SubScriptTitle,
  SubScriptWrap,
} from '@/styles/common/termsdocument'

type TermsDocumentParams = {
  id: string
}

export const TermsDocument: React.FC = () => {
  const { width } = useWindowDimensions()
  const navigate = useNavigate()
  const { id } = useParams<TermsDocumentParams>()
  const document = termsData.find((doc) => doc.id === id)

  if (!document) {
    return (
      <NotFoundPageWrap>
        <NotFoundPageInner>
          <p>요청하신 약관 문서를 찾을 수 없습니다.</p>
          <CustomBtn
            className={width > 1200 ? 'health_btn_pc' : 'health_btn_mo'}
            color={COLOR.point1}
            bgColor={COLOR.white}
            borderRadius={'40px'}
            borderColor={COLOR.point1}
            marginTop={width > 1200 ? '68px' : '38px'}
            width={width > 1200 ? '356px' : '328px'}
            height={width > 1200 ? '56px' : '44px'}
            fontSize={width > 1200 ? '18px' : '14px'}
            fontFamily={
              width > 1200 ? 'NanumSquareNeoHeavy, sans-serif' : 'NotoSansBold, sans-serif'
            }
            onClick={() => navigate('https://www.familycare.ai/')}
          >
            <span>휴대폰가족보호로 이동</span>
          </CustomBtn>
        </NotFoundPageInner>
      </NotFoundPageWrap>
    )
  }

  return (
    <LayoutWrap>
      <LayoutSubPage>
        <SubScriptTitle>
          <p>유성 안부e음 휴대폰가족보호 서비스 신청 관련</p>
          <h1>{document.title}</h1>
        </SubScriptTitle>
        <SubScriptWrap>
          <SubScriptDesc dangerouslySetInnerHTML={{ __html: document.content }} />
        </SubScriptWrap>
      </LayoutSubPage>
    </LayoutWrap>
  )
}
